module.exports = __webpack_public_path__ + "img/logo-orange.07dc3555.svg";